<script lang='ts'>

    /* IMPORTS --------------------------------------------------------------------------------- */

    // STYLING
    import 'tailwindcss/tailwind.css';

    // CASSIOPEIA
    import {
        Button,
        Heading,
        InboxButton,
        InputEmail,
        Paragraph,
        SESSION_USER,
        UserForm,
    } from '@smatch/cassiopeia-web-components';

    /* INTERNALS ------------------------------------------------------------------------------- */

    let isSaved = false;
    let email: string | undefined;

    const onSave = (): void => {
        isSaved = true;
    };

</script>

<Heading size = 'md'>Update Email Address</Heading>

{#if !isSaved }

    <Paragraph css = '!mb-4'>
        Once you've updated your email, we will resend the confirmation message.
    </Paragraph>

    {#if $SESSION_USER !== null }
        <Paragraph css = '!mb-4'>
            Your current email is <strong>{ $SESSION_USER.email }</strong>.
        </Paragraph>
    {/if}

    <UserForm action = {'update'} user = { { ...$SESSION_USER, email } } on:save = { onSave }>

        <InputEmail
            bind:value = { email }
            placeholder = 'Email'
            isRequired = { true }
        />

        <div class = 's8-footer'>

            <Button
                type = 'button'
                label = 'Cancel'
                color = 'neutral'
                css = 'w-full'
                url = '#onboarding'
            />

            <Button
                css = 'w-full'
                type = 'submit'
                label ='Update Email'
            />

        </div>

    </UserForm>

{:else}

    {#if $SESSION_USER !== null && email !== undefined }

        <Paragraph>
            We've received your email update request. Please check your inbox for further instructions.
        </Paragraph>

        <InboxButton email = { email } />

        <Button
            type = 'button'
            label = 'Back to Overview'
            color = 'neutral'
            css = 'w-full'
            url = '#onboarding'
        />

    {/if}

{/if}

<style lang='postcss'>

    div.s8-footer {
        display: flex;
        column-gap: 10px;
        flex-grow: 1;
        align-items: flex-end;
    }

</style>